<template>
	<el-dialog :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" :title="dialogTitle" :visible.sync="dialogVisible" destroy-on-close width="800px">
		<div>
			<el-form ref="formRef" :model="form" :rules="rules" label-position="top" label-width="120px">
			
				<el-row :gutter="20">
					<el-col :span="11">
						<el-form-item label="发票抬头：" prop="invoiceTitle">
							<el-input v-model.trim="form.invoiceTitle" placeholder="请输入发票抬头" clearable/>
						</el-form-item>
					</el-col>

					<el-col :offset="1" :span="11">
						<el-form-item label="纳税人识别号：" prop="taxNumber">
							<el-input v-model.trim="form.taxNumber" placeholder="请输入纳税人识别号" clearable/>
						</el-form-item>
					</el-col>
				</el-row>

				<el-row :gutter="20">
					<el-col :span="11">
						<el-form-item label="开户银行：" prop="bankName">
							<el-input v-model.trim="form.bankName" placeholder="请输入开户银行" clearable/>
						</el-form-item>
					</el-col>

					<el-col :offset="1" :span="11">
						<el-form-item label="银行账号：" prop="bankAccount">
							<el-input v-model.trim="form.bankAccount" placeholder="请输入银行账号" clearable/>
						</el-form-item>
					</el-col>
				</el-row>

				<el-row :gutter="20">
					<el-col :span="11">
						<el-form-item label="公司地址：" prop="companyAddress">
							<el-input v-model.trim="form.companyAddress" placeholder="请输入公司地址" clearable/>
						</el-form-item>
					</el-col>

					<el-col :offset="1" :span="11">
						<el-form-item label="公司电话：" prop="companyPhone">
							<el-input v-model.trim="form.companyPhone" placeholder="请输入公司电话" clearable/>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
		</div>
		<template #footer>
			<div class="dialog-footer">
				<el-button size="small" @click="handleClose">关闭</el-button>
				<el-button size="small" type="primary" @click="handleConfirm"> 保存 </el-button>
			</div>
		</template>
	</el-dialog>
</template>

<script>
	export default {
		name: 'DialogInvoice',
		props: {
			dialogVisible: {
				type: Boolean,
				default: false
			},
			dialogTitle: {
				type: String,
				default: ''
			},
			form: {
				type: Object,
				default: {}
			},
			rules: {
				type: Object,
				default: {}
			}
		},
		data() {
			return {
				invoiceTypeList: [
					{
						label: '电子普通发票',
						value: 1
					},
					{
						label: '纸质普通发票',
						value: 2
					},
					{
						label: '增值税专用发票',
						value: 3
					}
				],
				titleTypeList: [
					{
						label: '个人',
						value: 1
					},
					{
						label: '企业',
						value: 2
					}
				]
			};
		},
		methods: {
			handleClose() {
				this.resetForm();
				this.$emit('cancel');
			},

			resetForm() {
				this.$refs['formRef'].resetFields();
			},

			handleConfirm() {
				this.$refs['formRef'].validate(valid => {
					if (valid) {
						if (this.dialogTitle == '新增发票') {
							this.$emit('addConfirmInfo', this.form);
						} else {
							this.$emit('modifyConfirmInfo', this.form);
						}
					}
				});
			}
		}
	};
</script>

<style lang="less" scoped>
	// 弹出框重置样式
	/deep/ .el-dialog__header {
		border-bottom: 1px dashed #e2e8f0;
		margin-right: 0;
		background: #f8fafc;
	}

	/deep/ .el-dialog__headerbtn .el-dialog__close {
		color: #3a434f;
		font-size: 24px;
	}

	/deep/ .el-dialog__footer {
		border-top: 1px solid #e8e8e8;
		padding: 18px;
	}

	/deep/ .el-dialog__body .el-form-item__label {
		line-height: 26px;
	}
</style>
